import { create } from "zustand";
import {
  HomePageDataV2APIResponse,
  Location,
  MadeForYou,
  madeForYouInitial,
  MostPopular,
  mostPopularInitial,
} from "./home-page-types";
import { ListingCardData } from "@/types/types";

interface HomePageStoreV2 {
  mostPopular: MostPopular;
  madeForYou: MadeForYou;
  loaded: boolean;
  listingsLocale: string;
  userSub: string | null;
  local_cities: Location[];
  most_popular_countries: Location[];
  most_popular_cities: Location[];
  initState: (
    homePageData: HomePageDataV2APIResponse,
    locale: string,
    userSub: string | null,
    setCache: (listings: ListingCardData[]) => void,
  ) => void;
}

export const useHomePageStoreV2 = create<HomePageStoreV2>((set, get) => ({
  mostPopular: mostPopularInitial,
  madeForYou: madeForYouInitial,
  loaded: false,
  listingsLocale: "en",
  local_cities: [],
  most_popular_countries: [],
  most_popular_cities: [],
  userSub: null,
  initState: (homePageData, locale, userSub, setCache) => {
    if (
      get().loaded &&
      get().listingsLocale === locale &&
      get().userSub === userSub
    )
      return;
    const {
      most_popular,
      made_for_you,
      local_cities,
      most_popular_countries,
      most_popular_cities,
    } = homePageData;
    const popularListings = most_popular?.listings ?? [];
    const madeForYouListings = made_for_you?.listings ?? [];
    let mostPopularListingIds: string[] = popularListings.map(
      (listing) => listing.listing_id,
    );
    let madeForYouListingIds: string[] = madeForYouListings.map(
      (listing) => listing.listing_id,
    );
    setCache([...popularListings, ...madeForYouListings]);
    set({
      mostPopular: { listings: [...mostPopularListingIds] },
      madeForYou: { listings: [...madeForYouListingIds] },
      local_cities: local_cities.list,
      most_popular_countries: most_popular_countries.list,
      most_popular_cities: most_popular_cities.list,
      loaded: true,
      listingsLocale: locale,
      userSub: userSub,
    });
    return;
  },
}));

//add loading block
